import { useMemo } from 'react'

import { AvatarNameSelectorDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export interface MemberOption {
  label: string
  value: string
}

export const useTeamMembers = (): {
  members: MemberOption[]
  loading: boolean
  error?: unknown
} => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(AvatarNameSelectorDocument, {
    variables: {
      companyId: company.id,
      ids: [],
      includeTeams: true,
    },
    fetchPolicy: 'cache-and-network',
  })

  const members = useMemo<MemberOption[]>(() => {
    const employeeNames = data?.employees?.employeeNames
    if (!employeeNames) return []

    return employeeNames.map((emp) => ({
      label: [emp.firstName, emp.lastName].filter(Boolean).join(' '),
      value: String(emp.id),
    }))
  }, [data?.employees?.employeeNames])

  return { members, loading, error }
}
